<template>
  <div class="main">
    <media-header-research/>
    <div class="blanks"></div>
    <div class="main-header">
      <el-row :gutter="10" style="
          display: flex;
          justify-content: flex-end;
          padding-top: calc(100vw * 80 / 1920);
        ">
        <el-col :lg="10" :sm="6" style="display: flex;">
          <img @click="toIndex()" src="https://bjlab.oss-cn-hangzhou.aliyuncs.com/image/research_logo.png"
               style="width: calc(100vw * 200 / 1920); height: calc(100vw * 85 / 1920)"/>
        </el-col>

        <el-col :lg="14" :sm="18" class="navbar">
          <div v-for="(item, index) in titles" :key="index" :class="item.selected ? 'title_selected' : ''" class="title"
               @click="toPage(item)">
            {{ item.title }}
          </div>
          <div class="title">
            <div style="
                display: flex;
                justify-content: center;
                align-items: center;
                width: calc(100vw * 50 /1920);
                height: calc(100vw * 50 /1920);
                border-radius: 50%;
                background-color: #4063f9;
                margin-top: calc(100vw * -10 /1920);
              ">
              <img src="../assets/icon/search.png"
                   style="width: calc(100vw * 35 /1920); height: calc(100vw * 35 /1920)"/>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-main>
      <el-row :gutter="10" style="margin-top: calc(100vw * 20 / 1920)">
        <el-col :span="24" style="display: flex;justify-content: center;">
          <img style="width: 100%; height:100%;" src="https://bjlab.oss-cn-hangzhou.aliyuncs.com/labs/women7.png"
               class="image-fit"/>
        </el-col>
      </el-row>
      <el-row class="media-768-proception media-768-margin" :gutter="10"
              style="margin-top: calc(100vw * 50 /1920); padding: calc(100vw * 40 /1920)">
        <el-col :span="24" class="item-title bold">Sensory emotion regulation
        </el-col>
        <el-col :span="24" class="item-title">感知调控</el-col>
        <el-col :lg="12" :sm="24" class="item-content" style="padding-right: calc(100vw * 82 /1920);">
          Sensory perception is the interface between brain and the physical world. Perception shapes our belief, taste
          and personality. Can we use this interface to augment our perception about the world? Can we use this
          interface to cure brain diseases? The lab is interested in interactions between sensory perception and
          cognitive functions, such as learning and emotion. Our goal is to bring multidisciplinary concepts and
          approaches to develop methods and devices that intervene brain functions through sensory interfaces. At the
          same time, we are keen on educating the next generation of scientists and engineers who are willing to cross
          the traditional boundaries of science, technology, engineering and medicine.
        </el-col>
        <el-col :lg="12" :sm="24" class="media-1200-perception" style="
            display: flex;
            justify-content: center;
            align-items: center;
            border-left: calc(100vw * 1 /1920) solid #c0bfbe;
          ">
          <img src="https://bsd-files.oss-cn-hangzhou.aliyuncs.com/BaoJin/research/regulation.png" class="image-fit"/>
        </el-col>

        <el-col :span="24" class="item-publications bold media-768-margin" style="margin-top: calc(100vw * 50 /1920)">
          Publications
        </el-col>

        <el-col :span="24" class="item-content bold" style="margin-top: 30px">
          Extending visible light spectrum
        </el-col>
        <el-col :span="24" class="item-author" style="margin-top: 10px">
          <span>
            Ma Y#, <b>Bao J#*</b>, Zhang Y#, Li Z, Zhou Z, Zhou X, Wan C, Huang L, Zhao
          Y, Han G*, Xue T*. <i>Mammalian Near-Infrared Image Vision through
          Injectable and Self-Powered Retinal Nanoantennae.</i> Cell, 2019, 177(2):
          243-255 (<b>‘Best of Cell 2019’ award</b>)
          </span>
        </el-col>

        <el-col :span="24" class="item-content bold" style="margin-top: 30px">
          Light modulates mood
        </el-col>
        <el-col :span="24" class="item-author" style="margin-top: 10px">
         <span>
          An K#, Zhao H#*, Miao Y, Xu Q, Li YF, Ma YQ, Shi YM, Shen JW, Meng JJ,
          Yao YG, Zhang Z, Chen JT, <b>Bao J</b>, Zhang M, Xue T*. <i>A circadian
          rhythm-gated subcortical pathway for nighttime-light-induced
          depressive-like behaviors in mice.</i> Nature Neuroscience 2020
          Jul;23(7):869-880.
         </span>
        </el-col>

        <el-col :span="24" class="item-publications bold media-768-margin" style="margin-top: calc(100vw * 50 /1920)">
          Collaborators
        </el-col>
        <el-col :span="24" class="item-content bold" style="margin-top: 30px">
          Prof. Tian XUE
        </el-col>
        <el-col :span="24" class="item-author" style="margin-top: 10px">
          University of Science and Technology of China Hefei
        </el-col>

        <el-col :span="24" class="item-link" style="margin-top: calc(100vw * 10 /1920)">
          <a target="_blank" href="http://www.xuelab.ustc.edu.cn/"><i style="color: #5f7dfb;">http://www.xuelab.ustc.edu.cn/</i></a>
        </el-col>

      </el-row>
      <el-row class="media-768-bgColor media-768-margin" :gutter="10"
              style="margin-top: calc(100vw * 50 /1920); padding: calc(100vw * 50 /1920)">

        <el-col :span="24" class="item-title bold">Oxytocin</el-col>
        <el-col :span="24" class="item-title">催产素</el-col>
        <el-col :lg="12" :sm="24" style="border-right: calc(100vw * 1 /1920) solid #c0bfbe;">
          <div class="item-content">
            Oxytocin is a neuropeptide released by oxytocin neurons in
            hypothalamus of brain. Oxytocin is involved in affection, social
            behavior and development. Oxytocin receptor are GPCRs located in
            both pre and post synaptic membranes. We are interested in the
            molecular, cellular and network function of oxytocin in development
            and social behaviors.
          </div>
          <div class="media-768-oxytocin1" style="display: flex; justify-content: flex-end">
            <img src="https://bjlab.oss-cn-hangzhou.aliyuncs.com/image/research_oxytocin_1.png"/>
          </div>
        </el-col>
        <el-col class="media-768-oxytocin2" :lg="12" :sm="24" style="
            display: flex;
            justify-content: center;
            align-items: center;
          ">
          <img src="https://bjlab.oss-cn-hangzhou.aliyuncs.com/image/research_oxytocin_2.png" class="image-fit"/>
        </el-col>

        <el-col class="media-1200-oxytocin" :lg="12" :sm="24" style="
            display: flex;
            justify-content: center;
            align-items: center;
          ">
          <img src="https://bjlab.oss-cn-hangzhou.aliyuncs.com/image/research_oxytocin_1.png"/>
          <img src="https://bjlab.oss-cn-hangzhou.aliyuncs.com/image/research_oxytocin_2.png" class="image-fit"/>
        </el-col>

        <!-- 768尺寸显示的图片 -->
        <el-col class="media-768-oxytocinBg">
          <div>
            <img src="https://bjlab.oss-cn-hangzhou.aliyuncs.com/image/research_oxytocin_2.png" alt=""/>
          </div>
          <div>
            <img src="https://bjlab.oss-cn-hangzhou.aliyuncs.com/image/research_oxytocin_1.png" alt=""/>
          </div>
        </el-col>

        <el-col :span="24" class="item-publications bold media-768-margin" style="margin-top: calc(100vw * 50 /1920)">
          Publications
        </el-col>

        <el-col :span="24" class="item-content bold" style="margin-top: 30px">
          Oxytocin mediates sensory input promoted brain development
        </el-col>
        <el-col :span="24" class="item-author" style="margin-top: 10px;">
          <span>
            HU JiaXi#, SHI Yiming#,..., <b>BAO Jin*</b>, XUE Tian* <i>Melanopsin retinal ganglion cells mediate light-promoted brain development.</i> Cell 2022 Aug 18;185(17):3124-3137.
          </span>
        </el-col>

        <el-col :span="24" class="item-content bold" style="margin-top: 30px">
          Oxytocin modulates human brain connectivity
        </el-col>
        <el-col :span="24" class="item-author" style="margin-top: 10px;">
          <span>
            ZHANG Haoming., CHEN Kang., <b>BAO Jin</b>. & WU Haiyan. <i>Oxytocin enhances the triangular association among behavior, resting‐state, and task‐state functional connectivity.</i> Human Brain Mapping 2023 Dec 1;44(17):6074-6089.
          </span>
        </el-col>

        <el-col :span="24" class="item-publications bold media-768-margin" style="margin-top: 50px">Collaborators
        </el-col>
        <el-col :span="24" class="item-content bold" style="margin-top: 20px">
          Prof. Valery Grinevich
        </el-col>
        <el-col :span="24" class="item-author" style="margin-top: 10px">
          Heidelberg University, Germany
        </el-col>

        <el-col :span="24" class="item-content bold" style="margin-top: 20px">
          Dr. Rebecca Piskorowski
        </el-col>
        <el-col :span="24" class="item-author" style="margin-top: 10px">
          Sorbonne University, Paris
        </el-col>

      </el-row>
      <el-row class="media-768-el media-768-margin" :gutter="10" style="margin-top: 50px; padding: 40px">
        <el-col :span="24" class="item-title bold">Synaptic Plasticity</el-col>
        <el-col :span="24" class="item-title">突触可塑性</el-col>
        <el-col :lg="12" :sm="24" class="item-content media-bor"
                style="border-right: 1px solid #c0bfbe;color: #3E3A39;padding-right: 35px;">
          Synapse is one of the most important structures where neurons
          communicate with each other and neuronal circuit is formed. Synaptic
          plasticity is a general hardware implementation of learning and
          adaptation in the nervous system. Representation of the changing world
          and algorithms for adaptations are encoded in the diversity and
          complexity of synaptic plasticity. In addition, dysfunction of synapse
          and plasticity underlie the majority of neuronal diseases, like
          developmental disorder, mental disorder and aging. We trying to
          understand rules of synaptic plasticity and its modulation, especially
          focusing on the modulatory factors in homeostatic plasticity.
        </el-col>
        <el-col class="media-768-plasticity" :lg="12" :sm="24"
                style="display: flex; justify-content: center; align-items: center">
          <img src="https://bjlab.oss-cn-hangzhou.aliyuncs.com/image/research_plasticity.png" style="width: 85%;"
               class="image-fit"/>
        </el-col>

        <el-col :span="24" class="item-publications bold media-768-margin" style="margin-top: 50px">Publications
        </el-col>

        <el-col :span="24" class="item-content bold" style="margin-top: 30px">
          Translation in Parkinson’s disease model
        </el-col>
        <el-col :span="24" class="item-author" style="margin-top: 10px">
          <span>
          CHEN Yifei#, HONG Zexuan#, WANG Jingyi, <b>LIU Kunlin</b>,..., <b>BAO Jin*</b>, DAI Ji*, 
          and LU Zonghua* <i>Circuit-specific gene therapy reverses core symptoms in a primate Parkinson’s 
          disease model.</i> <b>Cell</b>. 2023 Nov 22;186(24):5394-5410.e18.
          </span>
        </el-col>

        <el-col :span="24" class="item-content bold" style="margin-top: 30px">
          Synsergistic action between postsynaptic receptors
        </el-col>
        <el-col :span="24" class="item-author" style="margin-top: 10px">
          <span>
            <b>Bao J</b>, Graupner M, Astorga G, Collin T, Jalil A, Indriati DW, Bradley
          J, Shigemoto R and Llano I. <i>Synergism of type 1 metabotropic and
          ionotropic glutamate receptors in cerebellar molecular layer
          interneurons in vivo.</i> <b>eLife</b>, 2020, 9, e56839
          </span>
        </el-col>

        <el-col :span="24" class="item-content bold" style="margin-top: 30px">
          Light modulates synaptic plasticity
        </el-col>
        <el-col :span="24" class="item-author" style="margin-top: 10px">
         <span> Cheng J, Huang X, Liang Y, Xue T, Wang L*, <b>Bao J*</b>. <i>Plasticity of
          Light-induced Concurrent Glutamatergic and GABAergic Quantal Events in
          the Suprachiasmatic Nucleus,</i> <b>Journal of Biological Rhythms</b>, 2018,
          33(1):65-75
        </span>
        </el-col>

        <el-col :span="24" class="item-content bold" style="margin-top: 30px">
          Target-dependent short-term synaptic plasticity
        </el-col>
        <el-col :span="24" class="item-author" style="margin-top: 10px">
         <span>
          <b>Bao J*</b>, Reim K, Sakaba T*. <i>Target-dependent feed-forward inhibition
          mediated by short-term synaptic plasticity in the cerebellum.</i> <b>Journal
          of Neuroscience</b>, 2010, 30:8171-8179.
         </span>
        </el-col>

        <el-col :span="24" class="item-content bold" style="margin-top: 30px">
          Information theory applied in synaptic plasticity
        </el-col>
        <el-col :span="24" class="item-author" style="margin-top: 10px">
        <span>
          Bibitchkov D, <b>Bao J</b>, and Neher E. <i>Information transmission by synapses
          with short-term synaptic plasticity.</i> <b>BMC Neuroscience</b>, 2007, 8(Suppl
          2), P90.
        </span>
        </el-col>
      </el-row>
      <el-row class="research-footer" :gutter="10" style="margin-top: 50px">
        <img
          :src="require('@/assets/image/footer_research.png')"
          style="width: 100%; display: block;"
        />
      </el-row>
    </el-main>
  </div>
</template>

<script>
  import mediaHeaderResearch from './media/mediaHeaderResearch'

  export default {
    name: "Index",
    components: {
      mediaHeaderResearch
    },
    data() {
      return {
        titles: [
          //'Research','People','Science And Art','Join Us','Contact Us'
          {
            title: "Research",
            key: "Research",
            selected: true,
          },
          {
            title: "People",
            key: "People",
          },
          {
            title: "Science And Art",
            key: "Science",
          },
          {
            title: "Join us",
            key: "Joinus",
          },
          {
            title: "Contact us",
            key: "Contactus",
          },
        ],
        current: 2,
      };
    },
    methods: {
      toPage(item) {
        this.$router.push(item.key);
      },
      toIndex() {
        this.$router.push({path: "/"});
      },
    },
  };
</script>

<style scoped>

  img {
    object-fit: contain;
  }

  html {
    min-width: 350px;
  }

  .blanks {
    display: none;
  }

  @media screen and (max-width: 1200px) {

    /*当屏幕尺寸小于1200px时，应用下面的CSS样式*/
    .main {
      width: 100%;
    }
  }

  /*当屏幕尺寸大于1200px时，应用下面的CSS样式*/
  @media screen and (min-width: 1200px) {
    .main {
      width: 80%;
      margin-left: 10%;
    }
  }

  @media screen and (min-width: 769px) and (max-width: 1400px) {
    .image-fit {
      width: 100%;
      height: 100%;
      object-fit: fill !important;
    }

    .media-768-oxytocin1 {
      justify-content: center !important;
    }

    .title {
      font-size: 14px !important;
    }

    .title_selected::after {
      bottom: 10px !important;
    }

    .media-1200-perception {
      height: auto !important;
    }

    .media-768-plasticity {
      margin-top: calc(100vw * 150 / 1920);
    }

    .media-768-oxytocin2 {
      margin-top: calc(100vw * 140 / 1920);
    }

    .media-1200-perception {
      margin-top: 80px !important;
    }

    .item-content {
      font-size: 16px !important;
    }

    .main-header {
      padding: 0 20px;
    }

    .item-publications {
      font-size: 20px !important;
    }

    .item-content {
      font-size: 13px !important;
      line-height: 20px !important;
    }

    .item-author {
      font-size: 10px !important;
      line-height: 20px !important;
    }

    .item-link {
      font-size: 10px !important;
    }
  }

  /* 屏幕尺寸大于768时 多媒体组件隐藏*/
  .media-768-header {
    display: none;
  }

  .media-768-oxytocin1 img {
    width: calc(100vw * 400 / 1920);
  }

  .media-768-oxytocin2 img {
    width: 81%;
  }

  .media-768-oxytocinBg {
    display: none;
  }

  .media-1200-perception {
    margin-top: calc(100vw * 25 / 1920);
  }

  .media-1200-perception img {
    width: 65%;
  }

  .main {
    overflow-x: hidden;
    overflow-y: hidden;
    text-rendering: optimizelegibility;
  }

  .navbar {
    font-family: bahnschrift;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: nowrap;
    cursor: pointer;
    letter-spacing: calc(100vw * -1 / 1920);
  }

  .title {
    font-family: 'mon';
    font-size: calc(100vw * 20 / 1920);
    color: #4063f9;
    padding-top: calc(100vw * 10 / 1920);
    text-rendering: optimizelegibility;
  }

  .title_selected {
    font-weight: bold;
    position: relative;
    letter-spacing: calc(100vw * -1 / 1920);
  }

  .title_selected::after {
    content: "__";
    letter-spacing: calc(100vw * -1 / 1920);
    color: #ff6a4a;
    font-weight: bold;
    position: absolute;
    left: calc(100vw * 10 / 1920);
    bottom: calc(100vw * 30 / 1920);
    font-size: calc(100vw * 25 / 1920);
  }

  .item {
    background-color: #ffffff;
    width: 15%;
    height: 65%;
    border: calc(100vw * 1 / 1920) solid #b4b4b4;
    margin: 0 0;
  }

  .selected {
    width: 20%;
    height: 75%;
    box-shadow: calc(100vw * 1 / 1920) calc(100vw * 1 / 1920) #b4b4b4;
  }

  .item-title {
    display: flex;
    justify-content: flex-start;
    font-size: calc(100vw * 45 / 1920);
    color: #4063f9;
    text-align: left;
  }

  .bold {
    font-weight: bold;
  }

  .item-content {
    margin-top: calc(100vw * 25 / 1920);
    display: flex;
    justify-content: flex-start;
    text-align: left;
    font-size: calc(100vw * 20 / 1920);
    color: #848382;
    line-height: calc(100vw * 32 / 1920);
    letter-spacing: calc(100vw * 1 / 1920);
  }

  .item-author {
    margin-top: calc(100vw * 25 / 1920);
    display: flex;
    justify-content: flex-start;
    text-align: left;
    font-size: calc(100vw * 17 / 1920);
    color: #848382;
    line-height: calc(100vw * 32 / 1920);
    letter-spacing: calc(100vw * 1 / 1920);
  }

  .item-publications {
    display: flex;
    justify-content: flex-start;
    font-size: calc(100vw * 40 / 1920);
    color: #4063f9;
  }

  .item-link {
    display: flex;
    justify-content: flex-start;
    text-align: left;
    font-size: calc(100vw * 16 / 1920);
    color: #4063f9;
  }

  a {
    text-decoration: none;
  }

  .el-header,
  .el-footer {
    text-align: center;
    line-height: calc(100vw * 30 / 1920);
  }

  .el-main {
    padding: calc(100vw * 80 / 1920) 0 0 0;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  .image-fit {
    width: 100%;
    height: 100%;
  }

  /*当屏幕尺寸大于768px时，应用下面的CSS样式隐藏*/
  .header-hidden {
    display: none;
  }

  .media-768-header {
    display: none;
  }

  .media-768-footer {
    display: none;
  }

  .media-1200-oxytocin {
    display: none !important;
  }

  @media screen and (min-width: 769px) and (max-width: 1200px) {
    .media-768-oxytocin1 {
      display: none !important;
    }

    .media-768-oxytocin2 {
      display: none !important;
    }

    .media-1200-oxytocin {
      margin-top: 20px !important;
      display: flex !important;
    }

    .media-1200-oxytocin img {
      width: 50%;
    }

    /* 感知增强 */
    .media-768-proception > .el-col:nth-child(3) {
      padding-right: 0 !important;
      font-size: 13px !important;
      line-height: 24px;
    }

    .media-1200-perception {
      border-left: none !important;
    }
  }

  /*当屏幕尺寸小于768px时，应用下面的CSS样式*/
  @media screen and (max-width: 768px) {
    .blanks {
      display: block;
      width: 100%;
      height: 54px;
    }

    .media-768-line {
      padding: 0 40px;
    }

    .media-768-line img {
      width: 100%;
    }

    .media-768-margin {
      margin-top: 0 !important;
    }

    /* 大于768头部隐藏 */
    .main-header {
      display: none;
    }

    /* 大于768 Oxytocin隐藏 */
    .media-768-oxytocinBg {
      display: none;
    }

    /* main样式 */
    .el-main {
      padding: 0 !important;
    }

    .media-768-el {
      margin-top: 0 !important;
    }

    .media-768-proception {
      padding: 33px !important;
    }

    .media-768-bgColor {
      padding: 33px !important;
    }

    .item-title {
      font-size: 20px !important;
    }

    .item-content {
      font-size: 10px !important;
      line-height: 20px !important;
      margin-top: 10px !important;
      margin-bottom: 10px;
    }

    .media-bor {
      border-right: none !important;
      padding-right: 0 !important;
    }

    .item-publications {
      font-size: 20px !important;
    }

    .media-768-plasticity {
      margin-top: 10px;
    }

    .item-author {
      font-size: 11px !important;
      margin-top: 3px !important;
      line-height: 26px !important;
    }

    .media-768-bgColor {
      background-color: #fff !important;
    }

    .media-768-bgColor > .el-col:nth-child(3) {
      border-right: none !important;
      height: auto !important;
    }

    /* Oxytocin 图片隐藏 */
    .media-768-bgColor > .el-col:nth-child(3) img {
      display: none;
    }

    .media-768-oxytocinBg {
      display: flex;
      margin-top: 24px;
    }

    .media-768-oxytocinBg > div {
      width: 50%;
      height: auto;
    }

    .media-768-oxytocinBg > div > img {
      width: 100%;
      height: 100%;
    }

    .media-768-oxytocin2 {
      display: none !important;
    }

    .item-publications {
      margin-top: 31px !important;
    }

    .item-link {
      font-size: 12px !important;
    }

    /* 感知增强 */
    .media-768-proception > .el-col:nth-child(3) {
      padding-right: 0 !important;
    }

    .media-1200-perception {
      border-left: none !important;
    }

    /* 页脚 */
    .research-footer {
      display: none;
    }
  }

  @media screen and (min-width: 2000px) and (max-width: 3000px) {

    .image-fit {
      width: auto;
      height: auto;
    }

  }

  @media screen and (min-width: 3000px) {
    * {
      font-size: calc(100vw * 14 / 1920) !important;
    }

    .media-768-el {
      padding: calc(100vw * 40  / 1920) !important;
    }

    .main {
      width: 70%;
      margin: 0 auto;
    }

    .search_icon {
      width: calc(100vw * 28 / 1920) !important;
      height: calc(100vw * 28 / 1920) !important;
    }

    .title {
      font-size: calc(100vw * 20 / 1920) !important;
      display: flex;
      justify-content: center;
    }

    .title > div {
      width: calc(100vw * 50 / 1920) !important;
      height: calc(100vw * 50 / 1920) !important;
    }

    .title img {
      width: 70% !important;
      height: 70% !important;
    }

    .title-icon {
      width: calc(100vw * 28 / 1920) !important;
      height: calc(100vw * 28 / 1920) !important;
    }

    .title_selected::after {
      font-size: calc(100vw * 28 / 1920) !important;
      bottom: calc(100vw * 30 / 1920) !important;
    }

    .item-title {
      font-size: calc(100vw * 28 / 1920) !important;
    }

    .item-content {
      font-size: calc(100vw * 17 / 1920) !important;
      line-height: calc(100vw * 22 / 1920) !important;
    }

    .item-author span {
      line-height: calc(100vw * 18 / 1920) !important;
    }

    .media-768-plasticity {
      height: calc(100vw * 300 / 1920) !important;
    }

    .image-fit {
      object-fit: contain !important;
    }

    .item-publications {
      font-size: calc(100vw * 24 / 1920) !important;
    }

    .media-768-oxytocin1 {
      width: 100%;
    }

    .media-768-oxytocin1 img {
      width: calc(100vw * 400 / 1920);
      height: calc(100vw * 300 / 1920);
    }

    .media-768-oxytocin1 img {
      object-fit: contain;
    }

    .media-768-oxytocin2 {
      width: 50%;
    }

    .media-768-oxytocin2 img {
      width: 80%;
    }

    .media-1200-perception img {
      width: 70%;
    }

    .media-768-line {
      height: calc(100vw * 30 / 1920) !important;
    }

    .media-768-line img {
      width: 30%;
      height: calc(100vw * 20 / 1920) !important;
      object-fit: contain;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Research.vue